import { Tooltip } from "..";

const TextArea = (props: any) => {
  return (
    <div className={'filter-fields ' + props.additionalClass} key={props.name}>
      {props.labelExternal ? <h3 className="title">{props.label}</h3> : null}
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
      <textarea
        // {...props}
        name={props.name}
        className="form-control"
        disabled={props.disabled}
        placeholder={props.placeholder !== "" ? props.placeholder : null}
        onChange={(e) => props.onChange({ name: props.name, value: e.target.value })}>
          {props.defaultSelected}
          </textarea>
        </div>
        {
          props.hasTooltip &&
          <div className="p-2">
            <Tooltip title={props.label}
              text={props.tooltipText} />
          </div>
        }
      </div>
    </div>
  );
};

export default TextArea;
